import { ScreenSize } from '../../../enums';
import styled from 'styled-components';
import MenuItem from './MenuItem/MenuItem';
import palette from '@mlc/mlc-palette';
import { Card, Col } from '@mlc/web-ui-toolkit';

export const NavCard = styled(Card)`
	@media (min-width: ${ScreenSize.small}) {
		height: 100px;
	}
`;

export const NavCol = styled(Col)`
	display: flex;

	@media (max-width: ${ScreenSize.xSmall}) {
		flex-direction: column;
	}
`;
export const NavLinksContainer = styled.nav`
	display: flex;
	flex: 1;
	justify-content: flex-end;
	padding: 0;
	width: 100%;

	@media (max-width: ${ScreenSize.xSmall}) {
		flex: none;
	}
`;

export const Ul = styled.ul`
	align-items: center;
	display: flex;
	flex-direction: row;
	flex-wrap: no-wrap;
	justify-content: space-between;
	list-style: none;
	margin-bottom: 0;
	margin-top: 0;
	padding: 0;
	padding-left: 0;

	@media (max-width: ${ScreenSize.medium}) {
		flex-wrap: wrap;
		justify-content: flex-start;
	}
`;

export const Logo = styled.img`
	height: 100%;
	margin-right: 2rem;
	max-height: 55px;
	max-width: 83px;
	transition: all 0.25s linear;
	width: auto;

	@media (max-width: ${ScreenSize.medium}) {
		margin-right: 30px;
	}

	@media (max-width: ${ScreenSize.small}) {
		align-self: flex-start;
		height: 40px;
		margin: 12px 25px 0 0;
	}

	@media (max-width: ${ScreenSize.xSmall}) {
		height: 2rem;
		margin: 0 0 15px 0;
	}
`;

export const LicenseeMenuItem = styled(MenuItem)`
	border: 2px ${palette.mlcBlack} solid;
	color: inherit;
	font-size: 16px;
	position: relative;
	text-decoration: none;

	&:focus,
	&:hover {
		color: ${palette.mlcBlack};
	}

	@media (min-width: ${ScreenSize.large}) {
		padding-right: 15px;
	}

	@media (min-width: ${ScreenSize.small}) {
		text-decoration: none;
	}

	@media (max-width: ${ScreenSize.small}) {
		border: none;
	}
`;

export const LogoLink = styled.a`
	align-items: center;
	display: flex;
	justify-content: center;
	margin: 0;
	padding: 0;

	@media (max-width: ${ScreenSize.xSmall}) {
		justify-content: left;
		padding-left: 10px;
	}
`;
